import { StandardEvents } from '@shopify/events';

/**
 * Holds part of a block that depends on the selected variant (e.g. the personalization field).
 * When the shopper picks another variant, it takes the same element from the re-rendered section
 * and swaps it in. If it was showing before and after, it is left alone so typed text is kept.
 */
class VariantRefresh extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.section?.addEventListener(StandardEvents.productSelect, this.#onProductSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(StandardEvents.productSelect, this.#onProductSelect);
  }

  /** @param {Event & { promise?: Promise<any> }} event */
  #onProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      ?.then(({ detail }) => {
        const html = detail?.html;
        if (!html) return;

        const next = html.querySelector(`variant-refresh[data-block-id="${this.dataset.blockId}"]`);
        if (!next) return;

        const active = next.hasAttribute('data-active');
        if (active && this.hasAttribute('data-active')) return;

        this.innerHTML = next.innerHTML;
        this.toggleAttribute('data-active', active);
      })
      .catch(() => {});
  };
}

if (!customElements.get('variant-refresh')) customElements.define('variant-refresh', VariantRefresh);
